import getEnv from "./getEnv";
import { Environ } from "./types";

const isTest = () => {
  return getEnv() === Environ.TEST;
};

export default isTest;
